import { removeNothings } from "@/lib/utils/arrays";

export type SummaryTableData = {
  id: string;
  feedyardName: string;
  monthlyCommitment: number | null;
  headCountEntered: number;
  planned: number;
  booked: number;
  shipped: number;
  percentFilled: string;
};

type SummaryEdge = Maybe<{
  node: Maybe<{
    numHead: Maybe<number>;
    numHeadPlanned: Maybe<number>;
    numHeadBooked: Maybe<number>;
    numHeadShipped: Maybe<number>;
    supplyChainPartner: Maybe<{
      id: string;
      businessName: Maybe<string>;
      monthlyTarget: Maybe<number>;
    }>;
  }>;
}>;

export const transformSummaryTableData = (edges: SummaryEdge[]): SummaryTableData[] => {
  return removeNothings(
    edges.map((edge) => {
      const node = edge?.node;
      if (!node?.supplyChainPartner) return null;

      const totalHead = node.numHead || 0;
      const monthlyTarget = node.supplyChainPartner.monthlyTarget || 0;
      const percentFilled = monthlyTarget > 0 ? `${Math.round((totalHead / monthlyTarget) * 100)}%` : "\u2014";

      return {
        id: node.supplyChainPartner.id,
        feedyardName: node.supplyChainPartner.businessName || "\u2014",
        monthlyCommitment: node.supplyChainPartner.monthlyTarget || null,
        headCountEntered: totalHead,
        planned: node.numHeadPlanned || 0,
        booked: node.numHeadBooked || 0,
        shipped: node.numHeadShipped || 0,
        percentFilled,
      };
    }),
  );
};
